import { render, staticRenderFns } from "./PreviousSchools.vue?vue&type=template&id=a387bec8&scoped=true"
import script from "./PreviousSchools.vue?vue&type=script&lang=js"
export * from "./PreviousSchools.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a387bec8",
  null
  
)

export default component.exports